export type Department = {
	ID: string;
	Type: string;
};
